export default __webpack_public_path__ + "static/media/allegretto.7f99db7f.png";